import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=fc5c5abe&scoped=true&"
import script from "./Compare.vue?vue&type=script&lang=js&"
export * from "./Compare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5c5abe",
  null
  
)

export default component.exports